var _rect, _line, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHfBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 496,
    height: 496,
    rx: 112,
    ry: 112,
    fill: "rgb(222,226,230)",
    fillOpacity: 0.9,
    stroke: "#111",
    strokeWidth: 16
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 256,
    y1: 96,
    x2: 256,
    y2: 416,
    stroke: "#111",
    strokeWidth: 10
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 292,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 170,
    fontWeight: 400,
    fill: "#111"
  }, "H")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 292,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 170,
    fontWeight: 400,
    fill: "#111"
  }, "F")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHfBackground);
export default __webpack_public_path__ + "static/media/logo-hf-background.0c19484258996f22a1f21a946c2dce82.svg";
export { ForwardRef as ReactComponent };